import { useEffect, useState, useRef } from 'react'

export function useFetch(url){
  const isCurrent = useRef(true)
  const [ state, setState ] = useState({ data: null, loading: true })

  useEffect(()=>{
    return () => {
      isCurrent.current = false
    }
  },[])

  useEffect(()=>{
    setTimeout(() => {
      setState(state=>({ data: state.data, loading: true }))
      $.ajax({
        url,
        success: (response) => {
          if (isCurrent.current) {
            setState({data: response, loading: false})
          }
        }
      })
    }, 5000);
  },[url, setState])

  return state
}